import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import queryString from 'query-string';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj, getDate } from 'lib/commonLib';
import { unpaidStatistics } from 'lib/api/time';

import FilterWrap from 'components/atoms/FilterWrap';
import MbCheckbox from 'components/atoms/MbCheckbox';
import TableContainer from 'components/molecules/MbTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {
  sDate: getDate(moment(moment().format('YYYY-MM-01'))),
  eDate: moment().add(-1, 'day').format('YYYYMMDD'),
  balance: 'N',
  balanceChecked: false,
};

const Unpaid = ({ location }) => {
  const { advrtsTpCode } = queryString.parse(location.search);

  if (typeof advrtsTpCode !== 'undefined') {
    initParam.advrtsTpCode = advrtsTpCode;
  }

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  const [balance, setBalance] = useState('N');
  const [balanceChecked, setBalanceChecked] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
        const dateValue = makeRowColumn(
          rowObj['STATS_DTTM'],
          'date',
          'YYYY-MM-DD'
        );
        const showWindowUrl =
          '/report/adver/unpaid?sDate=' +
          rowObj['STATS_DTTM'] +
          '&eDate=' +
          rowObj['STATS_DTTM'] +
          '&uri=/report/adver/unpaid&isPop=1';
        var dayOfWeek = new Date(dateValue).getDay();
        let dayColor;
        if (dayOfWeek === 0) {
          dayColor = 'red';
        } else if (dayOfWeek === 6) {
          dayColor = 'blue';
        }
        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['STATS_DTTM'],
              statsDttm.type,
              statsDttm.format
            )}
            textColor={dayColor}
            icon={rowObj['STATS_DTTM'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 날짜의 광고주별 상세 예산')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    },
    BDGT_LIMIT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              {getHeadObj(headsMap, 'BDGT_LIMIT').label}
              <br />
              (Vat미포함){' '}
            </>
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'BDGT_LIMIT');

        return (
          <>
            <span title={rowObj['BDGT_LIMIT']}>
              {makeRowColumn(rowObj['BDGT_LIMIT'], obj.type, obj.format)}
            </span>
          </>
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  const handleChangeValue = () => {
    let newParams;
    if (balance === 'Y') {
      setBalance('N');
      setBalanceChecked(false);
      newParams = {
        balance: 'N',
        balanceChecked: false,
      };
    } else {
      setBalance('Y');
      setBalanceChecked(true);
      newParams = {
        balance: 'Y',
        balanceChecked: true,
      };
    }

    setParams({
      ...params,
      ...newParams,
    });
  };

  const toolTipText = (
    <p>
      기본노출 데이터 (배너, 아이커버)
      <br />
      * 리타게팅 : CW + SR
      <br />
      * 유저타게팅 : UM + AD
      <br />
    </p>
  );

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
          noneExternalFilter={true}
          nonePltfomTpCodeFilter={true}
        />

        <FormControlLabel
          control={
            <MbCheckbox
              name="balance"
              onChange={(e) => handleChangeValue()}
              value={balance}
              checked={balanceChecked}
              color="#4ed1bd"
            />
          }
          label={t('잔여금액 1,000원 미만 제외')}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={unpaidStatistics}
            params={{ ...params }}
            sort="desc"
            order="STATS_DTTM"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
            noScroll
            noneSearch
            toolTip={toolTipText}
          />
        </>
      )}
    </>
  );
};

export default withRouter(Unpaid);
